import { ajaxService } from '../../common/Services';
import Collection from './domain-collection';
import { ApiUtils } from '../../common/api';
import RefData from "ref-data";

function fetchDomains(params = {}) {
  return ajaxService
    .get('/api/domain/list.json', {
      status: RefData.Enum.STATUS.DOMAIN.ACTIVE, // always only interested in active domains
      ...params,
    })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(Collection.deserialize)
    .catch(error => ({ error }));
}

function fetchAvailableDomains(channelTypeRef) {
  return ajaxService
    .get('/api/domain/listAvailable.json', { channelTypeRef })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(Collection.deserialize)
    .catch(error => ({ error }));
}

export default {
  fetchDomains,
  fetchAvailableDomains,
};
